import { useEffect, useState } from "react";

const defaultProps = {
  user: {},
  dir: "",
  isPublicView: false,
  ownerUserName: null,
  setDir: () => {},
};
export default function DirectoryComponent(props = defaultProps) {
  useEffect(() => {}, [props.isPublicView, props.ownerUserName]);

  //common
  const current_dir_controls = () => {
    if (props.isPublicView && !props.ownerUserName) return;
    return (() => {
      let dirPaths = [];
      let dirPathEls = [];

      let parts = props.dir.split("/");

      Array.from(parts).map((directory, index = 0) => {
        var _dir = dirPaths.join("/") + "/" + directory;

        if (_dir.charAt(0) != "/") _dir = "/" + _dir;

        var skipFirst = false;
        if (index === 0 && props.isPublicView && props.ownerUserName) {
          skipFirst = true;
          dirPathEls.push(
            <h5
              key={"root-dir"}
              className="dir-text"
              onClick={() => {
                props.setDir("/");
              }}
            >
              @{props.ownerUserName}
            </h5>
          );
        }

        dirPathEls.push(
          <h5
            data-dir={_dir}
            key={index + 5}
            className="dir-text"
            onClick={() => {
              props.setDir(_dir);
            }}
          >
            {directory}
          </h5>
        );

        dirPaths.push(directory.replaceAll("/", ""));

        if (index >= 1 || parts[1] !== "trash") {
          dirPathEls.push(
            <h5 key={-1 * index - 5} className="dir-text no-hover">
              /
            </h5>
          );
        }
      });

      return dirPathEls;
    })();
  };

  let dir_parts = props.dir.toLowerCase().split("/");
  if (dir_parts[0] === "trash" || dir_parts[1] === "trash") {
    return (
      <section className="dir-section dir-trash">
        <h5 className="dir-text no-hover trash-header">Trash Bin</h5>
        <p className="bin-subtext">Files and folders in the trash bin will be permenantly deleted after 7 days.</p>
        <div className="trash-dirs">
          {/*Logic for the current directory*/}
          {current_dir_controls()}
        </div>
      </section>
    );
  }

  return (
    <section className="dir-section">
      {!props.isPublicView && (
        <h5
          className="dir-text root-dir"
          onClick={() => {
            props.setDir("/");
          }}
        >
          {props.user ? props.user.username : ""}
        </h5>
      )}

      {/*Logic for the current directory*/}
      {current_dir_controls()}
    </section>
  );
}
